export const SLIDE_VAR_CHAR_LIMITS: Record<string, number> = {
  title: 60,
  subtitle: 80,
  body: 250,
};

export const SLIDE_ITEM_CHAR_LIMIT = 60;
